import { ModalChild } from './ModalByTextlink.child.client';
import type { ModalByTextlinkType } from './types';

/** Component that initializes multiple modal layers from texts from a CMS application with placeholders. Based on Shared Dialog: @packages/shared/Dialog */
export const ModalByTextlink = ({
  data: { field_content: content, paragraph },
}: {
  data: ModalByTextlinkType;
}) => (
  <div>
    {paragraph?.map((item, index) => (
      // eslint-disable-next-line react/no-array-index-key
      <ModalChild key={`textlink-modal-child-${index}`} replaceText={content ?? ''} data={item} />
    ))}
  </div>
);
